import React, { Component } from 'react';
var DatePicker = require('react-bootstrap-date-picker');
import JourneyChooser from './JourneyChooser';
import JourneySwitcher from './JourneySwitcher';
import Alert from './Alert';
import ReactToPrint from './ReactToPrint';
import CarePlan, { getModalDialogForPrinting, getCarePlanFileName } from './CarePlan';
import PeakFlowGuide from './PeakFlowGuide';
import ConfirmationModal from './ConfirmationModal';
import moment from 'moment';
import BP_METHODS from './BPMethods';


var Api = require('./Config');

import _ from 'lodash';





const BP_CONFIRMATIONS = {
    normal:'You are now requiring this patient to manually enter Blood Pressure . Do you want to proceed?',
    bp_cuff: 'You are now requiring this patient to ONLY use a Bluetooth Cuff. Do you want to proceed?',
    bp_ai: 'You are now requiring this patient to ONLY use Face Scan to retrieve blood pressure.  Do you want to proceed?'

}


const BP_TITLES = {
    normal:'Confirm Blood Pressure Requirement',
    bp_cuff: 'Confirm Bluetooth Cuff Requirement',
    bp_ai: 'Confirm Face Scan Requirement'

}



const singleRange = { display: 'flex', justifyContent: 'space-around', flexDirection: 'column', textAlign: 'center' };

// default values for guardrails
const guardRails = {
  MAIN: {
    low_emergency: 70,
    low_alert: 75,
    low_warning: 80,
    high_warning: 130,
    high_alert: 180,
    high_emergency: 250,
  },
  SYSTOLIC: {
    low_emergency: 85,
    low_warning: 95,
    low_alert: 90,
    high_warning: 140,
    high_alert: 145,
    high_emergency: 180,
  },
  DIASTOLIC: {
    low_emergency: 50,
    low_warning: 65,
    low_alert: 60,
    high_warning: 90,
    high_alert: 95,
    high_emergency: 120,
  },
};

const categoryGuardRailsMapping = {
  DMB: { MAIN: guardRails.MAIN },
  HTN: { SYSTOLIC: guardRails.SYSTOLIC, DIASTOLIC: guardRails.DIASTOLIC },
  AST: {
    MAIN: {
      low_alert: '',
      low_warning: '',
    },
  },
};

class DMCustomRange extends Component {
  constructor(props) {
    super(props);
    this.state = { ...props.guard_rails };
  }

  componentWillReceiveProps(newProps) {
    this.setState({ ...newProps.guard_rails });
  }

  changeValue(event, field) {
    _.set(this.state, field, event.target.value);
    this.setState({});
  }

  /**
   * Checks if guard rail fields should be rendered.
   * @param {string} guardRailType - MAIN, SYSTOLIC, DIASTOLIC
   * @param {string} alertType - low_alert, low_warning, high_warning, high_alert
   */
  shouldRenderField(guardRailType, alertType) {
    let categoryGuardRail = categoryGuardRailsMapping[this.props.category];
    if (categoryGuardRail) {
      if (guardRailType in categoryGuardRail && alertType in categoryGuardRail[guardRailType]) {
        return true;
      }
    }

    return false;
  }

  getFieldForSystolicDiastolic(numberInput) {
    // no SYSTOLIC or DYSTOLIC guardrail
    if (
      categoryGuardRailsMapping[this.props.category] &&
      !('SYSTOLIC' in categoryGuardRailsMapping[this.props.category]) &&
      !('DIASTOLIC' in categoryGuardRailsMapping[this.props.category])
    ) {
      return;
    }

    return (
      <div className="row">
        <div style={{ textAlign: 'center' }}>
          <b>Systolic</b>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
            {this.props.show_emergency_alert && (
              <div style={singleRange}>
                <div>
                  Low <br /> Emergency
                </div>
                <div>
                  <input
                    style={numberInput}
                    value={this.state.SYSTOLIC.low_emergency}
                    onChange={(e) => {
                      this.changeValue(e, 'SYSTOLIC.low_emergency');
                    }}
                    className="form-control"
                    type="number"
                  />
                </div>
              </div>
            )}
            <div style={singleRange}>
              <div>
                Low <br /> Critical
              </div>
              <div>
                <input
                  style={numberInput}
                  value={this.state.SYSTOLIC.low_alert}
                  onChange={(e) => {
                    this.changeValue(e, 'SYSTOLIC.low_alert');
                  }}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
            <div style={singleRange}>
              <div>
                Low <br /> Warning
              </div>
              <div>
                <input
                  style={numberInput}
                  value={this.state.SYSTOLIC.low_warning}
                  onChange={(e) => {
                    this.changeValue(e, 'SYSTOLIC.low_warning');
                  }}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
            <div style={singleRange}>
              <div>
                High <br /> Warning
              </div>
              <div>
                <input
                  style={numberInput}
                  value={this.state.SYSTOLIC.high_warning}
                  onChange={(e) => {
                    this.changeValue(e, 'SYSTOLIC.high_warning');
                  }}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
            <div style={singleRange}>
              <div>
                High <br /> Critical
              </div>
              <div>
                <input
                  style={numberInput}
                  value={this.state.SYSTOLIC.high_alert}
                  onChange={(e) => {
                    this.changeValue(e, 'SYSTOLIC.high_alert');
                  }}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
            {this.props.show_emergency_alert && (
              <div style={singleRange}>
                <div>
                  High <br /> Emergency
                </div>
                <div>
                  <input
                    style={numberInput}
                    value={this.state.SYSTOLIC.high_emergency}
                    onChange={(e) => {
                      this.changeValue(e, 'SYSTOLIC.high_emergency');
                    }}
                    className="form-control"
                    type="number"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <div style={{ marginTop: 20, textAlign: 'center' }}>
          <b>Diastolic</b>
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
            {this.props.show_emergency_alert && (
              <div style={singleRange}>
                <div>
                  Low <br /> Emergency
                </div>
                <div>
                  <input
                    style={numberInput}
                    value={this.state.DIASTOLIC.low_emergency}
                    onChange={(e) => {
                      this.changeValue(e, 'DIASTOLIC.low_emergency');
                    }}
                    className="form-control"
                    type="number"
                  />
                </div>
              </div>
            )}
            <div style={singleRange}>
              <div>
                Low <br /> Critical
              </div>
              <div>
                <input
                  style={numberInput}
                  value={this.state.DIASTOLIC.low_alert}
                  onChange={(e) => {
                    this.changeValue(e, 'DIASTOLIC.low_alert');
                  }}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
            <div style={singleRange}>
              <div>
                Low <br /> Warning
              </div>
              <div>
                <input
                  style={numberInput}
                  value={this.state.DIASTOLIC.low_warning}
                  onChange={(e) => {
                    this.changeValue(e, 'DIASTOLIC.low_warning');
                  }}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
            <div style={singleRange}>
              <div>
                High <br /> Warning
              </div>
              <div>
                <input
                  style={numberInput}
                  value={this.state.DIASTOLIC.high_warning}
                  onChange={(e) => {
                    this.changeValue(e, 'DIASTOLIC.high_warning');
                  }}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
            <div style={singleRange}>
              <div>
                High <br /> Critical
              </div>
              <div>
                <input
                  style={numberInput}
                  value={this.state.DIASTOLIC.high_alert}
                  onChange={(e) => {
                    this.changeValue(e, 'DIASTOLIC.high_alert');
                  }}
                  className="form-control"
                  type="number"
                />
              </div>
            </div>
            {this.props.show_emergency_alert && (
              <div style={singleRange}>
                <div>
                  High <br /> Emergency
                </div>
                <div>
                  <input
                    style={numberInput}
                    value={this.state.DIASTOLIC.high_emergency}
                    onChange={(e) => {
                      this.changeValue(e, 'DIASTOLIC.high_emergency');
                    }}
                    className="form-control"
                    type="number"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  getValuesForSystolicDiastolic() {
    // no SYSTOLIC or DYSTOLIC guardrail
    if (
      categoryGuardRailsMapping[this.props.category] &&
      !('SYSTOLIC' in categoryGuardRailsMapping[this.props.category]) &&
      !('DIASTOLIC' in categoryGuardRailsMapping[this.props.category])
    ) {
      return;
    }

    let groupedValues = _.groupBy(this.props.all_rails, 'on_date');
    return (
      <div style={{ textAlign: 'center', marginTop: 20 }}>
        <b>Previous Guardrails</b>
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>Date</th>
              {this.props.show_emergency_alert && <th>Low Emergency</th>}
              <th>Low Critical</th>
              <th>Low Warning</th>
              <th>High Warning</th>
              <th>High Critical</th>
              {this.props.show_emergency_alert && <th>High Emergency</th>}
            </tr>
          </thead>
          <tbody>
            {_.map(groupedValues, (values, index) => {
              const systolic = _.find(values, (a) => a.measure_type == 'SYSTOLIC');
              const diastolic = _.find(values, (a) => a.measure_type == 'DIASTOLIC');
              return (
                <tr>
                  <td>{index}</td>
                  {this.props.show_emergency_alert && (
                    <td>
                      {systolic.low_emergency}/{diastolic.low_emergency}
                    </td>
                  )}
                  <td>
                    {systolic.low_alert}/{diastolic.low_alert}
                  </td>
                  <td>
                    {systolic.low_warning}/{diastolic.low_warning}
                  </td>
                  <td>
                    {systolic.high_warning}/{diastolic.high_warning}
                  </td>
                  <td>
                    {systolic.high_alert}/{diastolic.high_alert}
                  </td>
                  {this.props.show_emergency_alert && (
                    <td>
                      {systolic.high_emergency}/{diastolic.high_emergency}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  getFieldForMain(numberInput) {
    // no MAIN guardrail
    if (categoryGuardRailsMapping[this.props.category] && !('MAIN' in categoryGuardRailsMapping[this.props.category])) {
      return;
    }

    return (
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around' }}>
        {this.props.show_emergency_alert && (
          <div style={singleRange}>
            <div>
              Low <br /> Emergency
            </div>
            <div>
              <input
                style={numberInput}
                value={this.state.MAIN.low_emergency}
                onChange={(e) => {
                  this.changeValue(e, 'MAIN.low_emergency');
                }}
                className="form-control"
                type="number"
              />
            </div>
          </div>
        )}
        {this.shouldRenderField('MAIN', 'low_alert') && (
          <div style={singleRange}>
            <div>
              Low <br /> Critical
            </div>
            <div>
              <input
                style={numberInput}
                value={this.state.MAIN.low_alert}
                onChange={(e) => {
                  this.changeValue(e, 'MAIN.low_alert');
                }}
                className="form-control"
                type="number"
              />
            </div>
          </div>
        )}
        {this.shouldRenderField('MAIN', 'low_warning') && (
          <div style={singleRange}>
            <div>
              Low <br /> Warning
            </div>
            <div>
              <input
                style={numberInput}
                value={this.state.MAIN.low_warning}
                onChange={(e) => {
                  this.changeValue(e, 'MAIN.low_warning');
                }}
                className="form-control"
                type="number"
              />
            </div>
          </div>
        )}
        {this.shouldRenderField('MAIN', 'high_warning') && (
          <div style={singleRange}>
            <div>
              High <br /> Warning
            </div>
            <div>
              <input
                style={numberInput}
                value={this.state.MAIN.high_warning}
                onChange={(e) => {
                  this.changeValue(e, 'MAIN.high_warning');
                }}
                className="form-control"
                type="number"
              />
            </div>
          </div>
        )}
        {this.shouldRenderField('MAIN', 'high_alert') && (
          <div style={singleRange}>
            <div>
              High <br /> Critical
            </div>
            <div>
              <input
                style={numberInput}
                value={this.state.MAIN.high_alert}
                onChange={(e) => {
                  this.changeValue(e, 'MAIN.high_alert');
                }}
                className="form-control"
                type="number"
              />
            </div>
          </div>
        )}
        {this.props.show_emergency_alert && (
          <div style={singleRange}>
            <div>
              High <br /> Emergency
            </div>
            <div>
              <input
                style={numberInput}
                value={this.state.MAIN.high_emergency}
                onChange={(e) => {
                  this.changeValue(e, 'MAIN.high_emergency');
                }}
                className="form-control"
                type="number"
              />
            </div>
          </div>
        )}
      </div>
    );
  }

  getValuesForMain() {
    // no MAIN guardrail
    if (categoryGuardRailsMapping[this.props.category] && !('MAIN' in categoryGuardRailsMapping[this.props.category])) {
      return;
    }

    return (
      <div style={{ textAlign: 'center', marginTop: 20 }}>
        <b> Previous Guardrails</b>
        <table className="table table-striped table-hover">
          <thead>
            <tr>
              <th>Date</th>
              {this.props.show_emergency_alert && <th>Low Emergency</th>}
              <th>Low Critical</th>
              <th>Low Warning</th>
              <th>High Warning</th>
              <th>High Critical</th>
              {this.props.show_emergency_alert && <th>High Emergency</th>}
            </tr>
          </thead>
          <tbody>
            {_.map(this.props.all_rails, (rail) => {
              return (
                <tr>
                  <td>{rail.on_date}</td>
                  {this.props.show_emergency_alert && <td>{rail.low_emergency}</td>}
                  <td>{rail.low_alert}</td>
                  <td>{rail.low_warning}</td>
                  <td>{rail.high_warning}</td>
                  <td>{rail.high_alert}</td>
                  {this.props.show_emergency_alert && <td>{rail.high_emergency}</td>}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    let numberInput = { width: 100 };
    if (this.props.show_emergency_alert) {
      numberInput = { width: 80 };
    }

    return (
      <div style={{ marginBottom: 20 }}>
        <div style={{ fontWeight: 'bold' }}>Set Guardrails:</div>
        {this.getFieldForMain(numberInput)}
        {this.getFieldForSystolicDiastolic(numberInput)}
        {this.props.category === 'AST' && (
          <div style={{ marginTop: 10, marginBottom: 10 }}>
            <PeakFlowGuide />
          </div>
        )}
        {this.props.all_rails.length > 0 && this.getValuesForMain()}
        {this.props.all_rails.length > 0 && this.getValuesForSystolicDiastolic()}
      </div>
    );
  }
}

class RequiredMark extends Component {
  render() {
    return <span style={{ color: 'red' }}>*</span>;
  }
}

export default class AddTCode extends Component {
  constructor(props) {
    super(props);
    console.log(props);
    this.guard_rails = guardRails;

    this.all_rails = [];

    var nowYear = new Date().getFullYear();
    this.state = {
      cluster_apps: [],
      offices: [],
      groups: [],
      show_office_selector: false,
      selectedOffice: 0,
      selected_app: -1,
      fallback_emergency_msg_txt: '',
      emergency_msg_txt: '',
      phone_link: '',
      ref_id: '',
      pat_ini: '',
      doc_id: '',
      gender: '',
      origJourneyJID: null,
      journeyModal: false,
      patient_ref: '',
      journey: {},
      start_date: '',
      loading: false,
      yob: '',
      alertVisible: false,
      group_name: '',
      doctor_comment: '',
      bp_method: 'normal',  // normal, bp_cuff, bp_ai
      allowed_bp_methods: ['normal','bp_cuff','bp_ai'],

      weight_required: false,
      weight_baseline: null,
      weight_baseline_required: false,
      confirmationModal: false,
      infoConfirmModal: false,
      hl7_match_2: '',
      hl7_match_2_mask_value: '',
      error_ref_id: '',
      error_pat_ini: '',
      error_yob: '',
      error_group_name: '',
      error_gender: '',
      error_doc_id: '',
      error_doctor_comment: '',
      error_journey_id: '',
      error_hl7_match_2: '',
      error_selected_app: '',
      enableSubmit: false,
      officeDetail: {},
    };
    this.dateRange = _.range(nowYear - 100, nowYear + 1);
    this.user_role = this.props.userObj.role;
    this.formRef = React.createRef();
  }



  componentDidUpdate(prevProps, prevState) {

    if(this.state.officeDetail==null || this.state.officeDetail==undefined  )
    {
      return ;
    }

      if(prevState.officeDetail.id != this.state.officeDetail.id) {
          // if the office detail changes, we need to update the allowed bp methods
          if(this.state.officeDetail.ai_bp_allowed=='Y')
          {
            //here
            this.state.allowed_bp_methods = ['normal','bp_cuff','bp_ai'];

          }
          else{
            this.state.allowed_bp_methods = ['normal','bp_cuff'];
          }
          this.state.default_bp_method = this.state.officeDetail.default_bp_method || 'normal';
          this.setState({});
      }


  }



  getJourneyForPatient() {
    Api.getJourneyForPatient(this.state.ref_id + this.state.pat_ini + '-%')
      .then((journeys) => {
        this.setState({ journeys });
        this.setState({ askDialogVisible: true });
      })
      .catch((err) => {
        alert(err);
      });
  }

  getEmergencyResponse(jid, doc_id, tcode_id = null) {
    Api.getEmergencyResponse(jid, doc_id, tcode_id)
      .then((data) => {
        // only populate the textarea when the response text is a tcode override
        let text = '';
        if (data.response.tcode_response) {
          text = data.response.tcode_response;
        }

        let fallback_text = '';
        if (data.response.office_response) {
          fallback_text = data.response.office_response;
        } else if (data.response.journey_response) {
          fallback_text = data.response.journey_response;
        } else if (data.response.default_response_text) {
          fallback_text = data.response.default_response_text;
        }

        this.setState({
          fallback_emergency_msg_txt: fallback_text,
          emergency_msg_txt: text,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  handleJourneySelect(journey) {
    // set guardrails
    if (journey.category in categoryGuardRailsMapping) {
      // deep clone the default values so it won't be affected when input values are changed
      // we want to make sure that everytime journey changes, values go back to default
      let newGuardrails = _.cloneDeep(categoryGuardRailsMapping);
      this.guard_rails = newGuardrails[journey.category];
    }

    // set emergency message
    if (journey.show_emergency_alert === 'Y') {
      let doc_id = this.state.officeDetail.doctor_id ? this.state.officeDetail.doctor_id : this.state.selectedOffice;
      this.getEmergencyResponse(journey.JID, doc_id);
    } else {
      this.setState({ old_emergency_message: {}, emergency_message_text: '' });
    }

    let bpDeviceRequired = false;
    if (journey.support_bp_device === 'Y') {
      bpDeviceRequired =  true;
 

    }

    this.setState({
      journeyModal: false,
      journey: journey,
      bp_device_required: bpDeviceRequired,
      enableSubmit: this.toggleSubmit('JID', journey.JID),
    });
  }

  goToPatientList() {
    this.props.history.push('/patients');
  }

  componentDidMount() {
    this.journey = {};

    // When this runs, it sets RMG and MGDEMO to false, which can potentially override
    // the RMG and MGDEMO values for users and doctor office users. This function is really only
    // used by super user and manager for the dropdown that we display for them to select an app.
    if (this.user_role == Api.ROLE_SUPER || this.user_role == Api.ROLE_MANAGER) {
      Api.getAppsForManagers().then((pApps) => {
        const apps = pApps.map((obj) => {
          obj.clubname = decodeURIComponent(obj.clubname);
          return obj;
        });

        this.setState({ cluster_apps: apps, selected_app: -1, selectedOffice: 0 });
      });
    }

    Api.getOfficeDetail()
      .then((data) => {
        this.setGroups(data.app_code);
        this.setState({ officeDetail: data });
        debugger;
         console.log(
          'Office Detail: ',data
         ) 

        this.setState({
          bp_method:data.default_bp_method || 'normal',
        });
        //

        if(data.ai_bp_allowed=='Y')
        {
          //here
          this.state.allowed_bp_methods = ['normal','bp_cuff','bp_ai'];
        }
        else{
          this.state.allowed_bp_methods = ['normal','bp_cuff'];
        }
        this.setState({});
          

    
  
 
 //here
    


        //
      })
      .catch((err) => {
        console.log(err);
      });

    if (this.props.match.params.TID) {
      this.disablePatientFields = true;
      this.editMode = this.props.location.pathname.indexOf('edit_guard_rail') != -1;

      Api.getTCodeById(this.props.match.params.TID)
        .then(async (data) => {
          if (data.t_code) {
            let editOfficeDetail = await Api.getOfficeDetailById(data.t_code.DOC_ID);
            this.state.officeDetail = editOfficeDetail;

            this.journey = data.t_code;
            try {
              const patientParts = Api.getPatientRefParts(this.journey.patient_ref);
              this.state.ref_id = patientParts.mrn;
              this.state.pat_ini = patientParts.patientInitials;
              this.state.doc_id = patientParts.doctorCode;
            } catch (e) {}

            this.state.gender = this.journey.gender;
            this.state.group_name = this.journey.group_name;
            this.state.doctor_comment = this.journey.doctor_comment;
            this.state.patient_ref = this.journey.patient_ref;
            this.state.yob = this.journey.yob;
            this.state.hl7_match_2 = this.journey.hl7_match_2 ? this.journey.hl7_match_2 : '';
            this.state.hl7_match_2_mask_value = this.journey.hl7_match_2 ? this.journey.hl7_match_2 : '';

            if (this.editMode) {
              this.state.journey = this.journey;
            
              this.state.origJourneyJID = this.journey.JID;
              this.state.bp_device_required = this.journey.bp_device_required === 'Y';
              this.state.bp_method=this.journey.bp_method || 'normal';
              this.state.weight_required = this.journey.weight_required === 'Y';

              // if there is already a value to the baseline, allow edit
              if (this.journey.weight_baseline) {
                this.state.weight_baseline = this.journey.weight_baseline;
                this.state.weight_baseline_required = true;
              }

              if (this.journey.category === 'HTN') {
                if (data.guard_rail) {
                  this.guard_rails.SYSTOLIC = { ..._.find(data.guard_rail, (a) => a.measure_type == 'SYSTOLIC') };
                  this.guard_rails.DIASTOLIC = { ..._.find(data.guard_rail, (a) => a.measure_type == 'DIASTOLIC') };
                }
              } else if (this.journey.category === 'DMB' || this.journey.category === 'AST') {
                if (data.guard_rail) {
                  this.guard_rails.MAIN = data.guard_rail;
                }
              }

              if (this.journey.show_emergency_alert === 'Y') {
                this.getEmergencyResponse(this.journey.JID, this.journey.DOC_ID, this.journey.TID);
              }

              this.all_rails = data.all_rails;
            }
            this.setState({});
            console.log('Done00');
          }
        })
        .catch((err) => {
          alert(err + '');
          throw err;
        });
    }
  }

  getNewAlert() {
    if (!this.state.alertVisible) {
      return;
    }
    var result = this.state.result;

    return (
      <div className="modal show">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                onClick={() => {
                  this.setState({ alertVisible: false });
                }}
                className="close"
                data-dismiss="modal"
              >
                &times;
              </button>
              <h4 className="modal-title">Success</h4>
            </div>
            <div className="modal-body">{`Tcode "${Api.formatTCode(result.TCODE)}" is created`}</div>
            <div className="modal-footer">
              <button
                onClick={() => {
                  //  this.setState({journeyModal:false,journey:journey});
                  this.setState({
                    alertVisible: false,
                    journey: {},
                    journeyModal: true,
                    enableSubmit: this.toggleSubmit('JID', null),
                  });
                }}
                type="button"
                className="btn btn-success"
                data-dismiss="modal"
              >
                Add another for this patient
              </button>

              <button
                onClick={() => {
                  this.setState({ alertVisible: false });
                  this.getJourneyForPatient();
                  // this.goToPatientList();
                }}
                type="button"
                className="btn btn-primary"
                data-dismiss="modal"
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  /**
   * Checks if all guardrail values for a journey category has a value.
   * Returns valid guardrails if valid, false if invalid.
   */
  getValidGuardrails() {
    var valid = true;
    var validValues = {};

    if (categoryGuardRailsMapping[this.state.journey.category]) {
      let guardRailValues = _.get(this, 'DMCustomRange.state', {});
      let guardRail = categoryGuardRailsMapping[this.state.journey.category];

      _.each(guardRail, (guardRailFields, guardRailType) => {
        let values = guardRailValues[guardRailType];
        validValues[guardRailType] = {};
        _.each(guardRailFields, (fieldValue, fieldType) => {
          // skip validation for low_emergency and high_emergency values
          // if the journey does not allow to show emergency alerts
          if (
            this.state.journey.show_emergency_alert !== 'Y' &&
            (fieldType === 'low_emergency' || fieldType === 'high_emergency')
          ) {
            return;
          }

          // check if all values are provided
          if (!values[fieldType] || values[fieldType].toString().trim().length === 0) {
            valid = false;
            return false;
          } else {
            // insert valid values
            validValues[guardRailType][fieldType] = values[fieldType];
          }
        });
      });
    }

    if (valid) {
      return validValues;
    }

    return false;
  }

  toggleSubmit(key, value, setState = false) {
    const requiredFields = [
      'ref_id',
      'pat_ini',
      'yob',
      'gender',
      'doc_id',
      'JID',
      'hl7_match_2',
      'selected_app',
      'group_name',
    ];

    let isValid = requiredFields.every((field) => {
      if (field === 'hl7_match_2' && this.state.officeDetail.hl7_match_2_required != 'Y') {
        return true;
      }

      if (field === 'selected_app') {
        if (this.user_role == Api.ROLE_MANAGER || this.user_role == Api.ROLE_SUPER) {
          if (key === field) {
            return value != -1;
          } else {
            return this.state.selected_app != -1;
          }
        } else {
          return true;
        }
      }

      if (field === 'group_name') {
        if (this.state.groups.length <= 0) {
          return true;
        }
      }

      if (key == field) {
        return value && String(value).trim() != '';
      } else {
        if (field === 'JID') {
          return this.state.journey.JID ? true : false;
        } else {
          return this.state[field] && String(this.state[field]).trim() != '';
        }
      }
    });

    if (setState) {
      this.setState({
        enableSubmit: isValid,
      });
    }

    return isValid;
  }

  validateFields() {
    let valid = true;

    if (this.state.ref_id.trim() == '') {
      this.setState({ error_ref_id: 'Medical Record Number is required.' });
      valid = false;
    } else {
      this.setState({ error_ref_id: '' });
    }

    if (this.state.pat_ini.trim().length != 2) {
      this.setState({ error_pat_ini: "Patient's initials should be 2 letters." });
      valid = false;
    } else {
      this.setState({ error_pat_ini: '' });
    }

    if (this.state.yob.length <= 0) {
      this.setState({ error_yob: 'Year of Birth is required.' });
      valid = false;
    } else {
      this.setState({ error_yob: '' });
    }

    if (this.state.groups.length > 0) {
      if (this.state.group_name.length <= 0) {
        this.setState({ error_group_name: 'Group is required.' });
        valid = false;
      } else {
        this.setState({ error_group_name: '' });
      }
    }

    if (this.state.gender.trim() == '') {
      this.setState({ error_gender: 'Gender is required.' });
      valid = false;
    } else {
      this.setState({ error_gender: '' });
    }

    if (this.state.doc_id.trim() == '') {
      this.setState({ error_doc_id: 'Provider Code/NPI# is required.' });
      valid = false;
    } else {
      this.setState({ error_doc_id: '' });
    }

    if (this.state.officeDetail.npi_format_required === 'Y') {
      let doc_id_trimmed = this.state.doc_id.replaceAll(' ', '');
      if (doc_id_trimmed.length == 10 && [...doc_id_trimmed].every((c) => '0123456789'.includes(c))) {
        this.setState({ error_doc_id: '' });
      } else {
        this.setState({ error_doc_id: 'Provider NPI# is required and must be 10 numbers' });
        valid = false;
      }
    }

    if (this.state.journey.JID == null) {
      this.setState({ error_journey_id: 'Journey is required.' });
      valid = false;
    } else {
      this.setState({ error_journey_id: '' });
    }

    if (this.state.officeDetail.hl7_match_2_required === 'Y') {
      if (this.state.hl7_match_2.length == 0) {
        this.setState({ error_hl7_match_2: '2nd Matching Value is required.' });
        valid = false;
      } else if (!['19', '20'].includes(this.state.hl7_match_2.trim().substring(0, 2))) {
        this.setState({ error_hl7_match_2: '2nd Matching Value needs to start with 19 or 20' });
        valid = false;
      } else if (!moment(this.state.hl7_match_2.trim(), 'YYYYMMDD', true).isValid()) {
        this.setState({ error_hl7_match_2: '2nd matching value is not a valid date or in format of YYYYMMDD' });
        valid = false;
      } else {
        this.setState({ error_hl7_match_2: '' });
      }
    }

    if (this.user_role == Api.ROLE_MANAGER || this.user_role === Api.ROLE_SUPER) {
      if (this.state.selected_app == -1) {
        this.setState({ error_selected_app: 'App Code is required' });
        valid = false;
      } else {
        this.setState({ error_selected_app: '' });
      }
    }

    return valid;
  }

  confirmSaveTCode() {
    if (!this.validateFields()) {
      this.formRef.current.scrollIntoView();
      return;
    }

    let validGuardrails = this.getValidGuardrails();
    if (validGuardrails == false) {
      this.alert.open('Error', 'Please enter all values for guardrails.');
      return false;
    }

    if (this.state.journey.support_bp_device === 'Y') {
      // show confirmation if the bp_device_required value changed
      if (this.state.officeDetail.default_bp_method != this.state.bp_method) {
        this.setState({ confirmationModal: true });
        return false;
      }
    }

    // show confirmation
    this.setState({ infoConfirmModal: true });
    return false;
  }

  saveTCode(validGuardrails) {
    if (validGuardrails == null) {
      validGuardrails = this.getValidGuardrails();
    }

    this.setState({ loading: true, confirmationModal: false });

    Api.addTCode(
      this.state.journey.JID,
      this.state.patient_ref.trim(),
      this.state.start_date.trim(),
      this.state.yob,
      this.state.gender.trim(),
      validGuardrails,
      this.state.group_name,
      this.state.doctor_comment,
      this.state.selected_app,
      this.state.selectedOffice,
      this.state.emergency_msg_txt,
      this.state.bp_method,
      this.state.hl7_match_2,
      this.state.weight_required
    )
      .then((result) => {
        this.setState({ loading: false });
        console.log(result);
        if (result.RESULT == 'SUCCESS') {
          /*
            this.alert.open("Success",`Tcode "${Api.formatTCode(result.TCODE)}" is created`,()=>{
              this.goToPatientList();
            });
              */
          this.setState({ alertVisible: true, infoConfirmModal: false, result });
        } else {
          this.alert.open('Error', result.ERROR);
        }
      })
      .catch((e) => {
        this.setState({ loading: false });
        this.alert.open('Error', e + '');
      });
  }

  confirmUpdateTCode() {
    let validGuardrails = {};
    if (this.state.journey && this.state.journey.has_guard_rail === 'Y') {
      validGuardrails = this.getValidGuardrails();
      if (validGuardrails == false) {
        this.alert.open('Error', 'Please enter all values for guardrails.');
        return false;
      }
    }

    if (this.state.weight_baseline_required && parseInt(this.state.weight_baseline || 0) <= 0) {
      this.alert.open('Error', 'Please enter a weight baseline');
      return false;
    }

    // show confirmation if the bp_device_required value changed
    if ((this.state.journey.bp_device_required === 'Y') != this.state.bp_device_required) {
      this.setState({ confirmationModal: true });
      return false;
    }

    this.updateTCode(validGuardrails);
  }

  async updateTCode(validGuardrails) {
    try {
      if (this.state.journey && this.state.journey.has_guard_rail === 'Y') {
        if (validGuardrails == null) {
          validGuardrails = this.getValidGuardrails();
        }
        await Api.updateGuardRail(this.props.match.params.TID, validGuardrails);
      }

      if (this.state.journey && this.state.journey.show_emergency_alert === 'Y') {
        await Api.updateEmergencyResponseByTID(this.props.match.params.TID, this.state.emergency_msg_txt);
      }

      if (this.state.journey && this.state.journey.support_bp_device === 'Y') {
        await Api.updateTCode({
          TID: this.props.match.params.TID,
          bp_method: this.state.bp_method,
        });
      }

      if (this.state.journey && this.state.journey.category === 'HTN') {
        await Api.updateTCode({
          TID: this.props.match.params.TID,
          weight_required: this.state.weight_required,
          weight_baseline: parseInt(this.state.weight_baseline),
        });
      }

      if (this.state.origJourneyJID != this.state.journey.JID) {
        let result = await Api.switchJourney(
          this.state.origJourneyJID,
          this.state.journey.JID,
          this.state.journey.t_code
        );
        if (result.success == false) {
          this.alert.open('Error', result.reason);
          return false;
        }
      }

      this.goToPatientList();
    } catch (err) {
      this.alert.open('Error', 'Error: ' + err);
    }
  }

  async setGroups(clubID) {
    const medicalGroups = await Api.getAllGroups(clubID);
    if (medicalGroups.data.length > 0) {
      const allGroups = medicalGroups.data.filter((item) => item.active === 'Y').map((item) => item.group_code);
      if (allGroups.length > 0) {
        allGroups.unshift('None');
        this.setState({ groups: allGroups });
        return;
      }
    }

    this.setState({ groups: [], group_name: '' });
  }

  /**
   * Runs when office dropdown value changes
   * @param {int} office_id
   */
  async handleSelectedOffice(office_id) {
    let prevOfficeDetails = this.state.officeDetail || {};
    let officeDetail = await Api.getOfficeDetailById(office_id);

    officeDetail.RMG = prevOfficeDetails.RMG || false;
    officeDetail.MGDEMO = prevOfficeDetails.MGDEMO || false;
    officeDetail.TEST = prevOfficeDetails.TEST || false;
    officeDetail.RTTEST = prevOfficeDetails.RTTEST || false;
    officeDetail.vasentara = prevOfficeDetails.vasentara || false;
    officeDetail.VAHEALS = prevOfficeDetails.VAHEALS || false;
    officeDetail.CAWATTS = prevOfficeDetails.CAWATTS || false;
    officeDetail.PACONS = prevOfficeDetails.PACONS || false;
    officeDetail.CAAIHS = prevOfficeDetails.CAAIHS || false;
    officeDetail.CAPEACH = prevOfficeDetails.CAPEACH || false;
    officeDetail.DEPPHQ8 = prevOfficeDetails.DEPPHQ8 || false;
    officeDetail.RTCLONES = prevOfficeDetails.RTCLONES || false;
    officeDetail.CATEGORYBASED = prevOfficeDetails.CATEGORYBASED || false;
    officeDetail.WCCHC = prevOfficeDetails.WCCHC || false;

    this.setState({ selectedOffice: office_id, officeDetail: officeDetail });
  }

  /**
   * Runs when app dropdown value changes
   * @param {string} club_id
   * @param {obj} cluster_apps
   */
  async handleSelectedApp(club_id, cluster_apps) {
    this.setState({ selected_app: club_id, selectedOffice: 0 });

    let offices = await Api.getOfficeForAppId(club_id);

    if (offices.length <= 1) {
      this.setState({ show_office_selector: false });
    } else {
      this.setState({ show_office_selector: true, offices, selectedOffice: offices[0].id });
    }

    // if there are multiple offices for the selected app,
    // the selected office will be the first office in the list
    // so we need to get it's office detail and update the office detail state
    let officeDetail = {};
    if (offices.length > 0) {
      officeDetail = await Api.getOfficeDetailById(offices[0].id);
    }

    officeDetail.RMG = cluster_apps.find((a) => a.club_id == club_id).RMG;
    officeDetail.MGDEMO = cluster_apps.find((a) => a.club_id == club_id).MGDEMO;
    officeDetail.TEST = cluster_apps.find((a) => a.club_id == club_id).TEST;
    officeDetail.RTTEST = cluster_apps.find((a) => a.club_id == club_id).RTTEST;
    officeDetail.vasentara = cluster_apps.find((a) => a.club_id == club_id).vasentara;
    officeDetail.VAHEALS = cluster_apps.find((a) => a.club_id == club_id).VAHEALS;
    officeDetail.CAWATTS = cluster_apps.find((a) => a.club_id == club_id).CAWATTS;
    officeDetail.PACONS = cluster_apps.find((a) => a.club_id == club_id).PACONS;
    officeDetail.CAAIHS = cluster_apps.find((a) => a.club_id == club_id).CAAIHS;
    officeDetail.DEPPHQ8 = cluster_apps.find((a) => a.club_id == club_id).DEPPHQ8;
    officeDetail.CAPEACH = cluster_apps.find((a) => a.club_id == club_id).CAPEACH;
    officeDetail.WCCHC = cluster_apps.find((a) => a.club_id == club_id).WCCHC;
    officeDetail.RTCLONES = cluster_apps.find((a) => a.club_id == club_id).RTCLONES;
    officeDetail.CATEGORYBASED = cluster_apps.find((a) => a.club_id == club_id).CATEGORYBASED;
    this.setState({ officeDetail: officeDetail });
    this.setGroups(club_id);
    this.toggleSubmit(null, null, true);
  }

  addPhoneLink() {
    const fullPhoneLink = '<PHONE_LINK>' + this.state.phone_link + '</PHONE_LINK>';
    this.setState({
      emergency_msg_txt: this.state.emergency_msg_txt + ' ' + fullPhoneLink,
      phone_link: '',
    });
  }

  render() {
    return (
      <div>
        {getModalDialogForPrinting(
          this.state.askDialogVisible,
          this.state.journeys,
          this.alert,
          (obj) => {
            this.setState(obj);
          },
          this.state.print_name,
          this.state.print_date,
          this.rtp,
          () => {
            //
            this.goToPatientList();
          }
        )}
        <div style={{ display: 'none' }}>
          <CarePlan
            phone={_.get(this.state, 'journeys[0].phone_number', '')}
            title={_.get(this.state, 'journeys[0].title', '')}
            print_date={this.state.print_date}
            print_name={this.state.print_name}
            tcodes={this.state.journeys}
            ref={(ref) => {
              this.carePlan = ref;
            }}
          />
        </div>
        <ReactToPrint
          ref={(acomp) => {
            this.rtp = acomp;
          }}
          content={() => {
            return this.carePlan;
          }}
          trigger={() => {}}
          documentTitle={getCarePlanFileName(this.state.print_name)}
        />
        <div>
          {!this.editMode && <h3>Add New T-Code</h3>}
          {this.editMode && <h3>Edit T-Code ({this.journey.t_code})</h3>}
        </div>
        <div
          className={
            _.get(this.state, 'journey.category', 'XXX') == 'HTN'
              ? 'col-md-6 col-md-offset-3 well'
              : 'col-md-6 col-md-offset-3 well'
          }
        >
          <form ref={this.formRef}>
            {this.editMode && (
              <div className="row">
                {' '}
                <div className="form-group col-md-8">
                  <label>
                    Medical Record Number (or a Ref #)
                    <br />
                    {this.journey.patient_ref}
                  </label>
                </div>
                <div className="form-group  col-md-4">
                  <label>
                    Group
                    <br />
                    {this.journey.group_name}
                  </label>
                </div>
              </div>
            )}

            {!this.editMode && (
              <div>
                <div className="row">
                  {(this.user_role == Api.ROLE_SUPER || this.user_role == Api.ROLE_MANAGER) && (
                    <div className={`form-group col-md-8 ${this.state.error_selected_app ? 'has-error' : ''}`}>
                      <label>
                        Select App Code <RequiredMark />
                      </label>
                      <select
                        value={this.state.selected_app}
                        onChange={(e) => {
                          this.handleSelectedApp(e.target.value, this.state.cluster_apps);
                        }}
                        className="form-control"
                      >
                        <option value="-1">Select App Code</option>
                        {this.state.cluster_apps.map((app) => (
                          <option key={app.clubname} value={app.club_id}>
                            {app.clubname}
                          </option>
                        ))}
                      </select>
                      {this.state.error_selected_app && (
                        <div className="error-message">{this.state.error_selected_app}</div>
                      )}
                    </div>
                  )}

                  {this.state.show_office_selector == true && (
                    <div className="form-group col-md-8">
                      <label>Select Office</label>
                      <select
                        className="form-control"
                        onChange={(e) => {
                          this.handleSelectedOffice(e.target.value);
                        }}
                        value={this.state.selectedOffice}
                      >
                        {this.state.offices.map((office) => (
                          <option value={office.id} key={office.id}>
                            {office.title}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  <div className={`form-group col-md-8 ${this.state.error_ref_id ? 'has-error' : ''}`}>
                    <label>
                      Medical Record Number (or a Ref #) <RequiredMark />
                    </label>
                    <input
                      readOnly={this.editMode || this.disablePatientFields}
                      type="text"
                      style={{ width: 200 }}
                      value={this.state.ref_id}
                      onChange={(e) => {
                        if (e.target.value.indexOf('-') !== -1) {
                          // return;
                        }
                        if (e.target.value.length > 10) {
                          return;
                        }
                        if (e.target.value.trim() != '') {
                          if (/^([A-Za-z0-9]|\-)+$/gi.test(e.target.value) === false) {
                            return;
                          }
                        }

                        this.setState({
                          ref_id: e.target.value,
                          patient_ref:
                            e.target.value + this.state.pat_ini + '-' + this.state.doc_id.trim().replaceAll(' ', ''),
                          enableSubmit: this.toggleSubmit('ref_id', e.target.value),
                        });
                      }}
                      className="form-control"
                      placeholder="Medical Ref#"
                    />
                    {this.state.error_ref_id && <div className="error-message">{this.state.error_ref_id}</div>}
                  </div>

                  {this.state.groups.length > 0 && (
                    <div className={`form-group col-md-4 ${this.state.error_group_name ? 'has-error' : ''}`}>
                      <label>
                        Group <RequiredMark />
                      </label>
                      <br />
                      <select
                        readOnly={this.editMode}
                        className="form-control"
                        style={{ width: 100, color: this.state.group_name != '' ? '#555' : '#999' }}
                        value={this.state.group_name}
                        onChange={(e) => {
                          this.setState({
                            group_name: e.target.value,
                            enableSubmit: this.toggleSubmit('group_name', e.target.value),
                          });
                        }}
                      >
                        <option value="" disabled selected hidden>
                          Group
                        </option>
                        {this.state.groups.map((group) => (
                          <option value={group} key={group}>
                            {group}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                </div>

                <div className={`form-group ${this.state.error_pat_ini ? 'has-error' : ''}`}>
                  <label>
                    Patient Initials (<span style={{ color: 'red' }}>must be two letters</span>) <RequiredMark />
                  </label>
                  <input
                    readOnly={this.editMode || this.disablePatientFields}
                    type="text"
                    style={{ width: 60 }}
                    value={this.state.pat_ini}
                    onChange={(e) => {
                      if (e.target.value.indexOf('-') !== -1) {
                        return;
                      }
                      if (e.target.value.length > 2) {
                        return;
                      }
                      if (e.target.value.trim() != '') {
                        if (/^[A-Za-z0-9]+$/gi.test(e.target.value) === false) {
                          return;
                        }
                      }
                      this.setState({
                        pat_ini: e.target.value,
                        patient_ref:
                          this.state.ref_id + e.target.value + '-' + this.state.doc_id.trim().replaceAll(' ', ''),
                        enableSubmit: this.toggleSubmit('pat_ini', e.target.value),
                      });
                    }}
                    className="form-control"
                    placeholder="Ini"
                  />
                  {this.state.error_pat_ini && <div className="error-message">{this.state.error_pat_ini}</div>}
                </div>

                {false && (
                  <div className="form-group">
                    <label>Medical Ref </label>
                    <input
                      readOnly={this.editMode || this.disablePatientFields}
                      type="text"
                      value={this.state.patient_ref}
                      className="form-control"
                      placeholder="Medical Ref#"
                    />
                  </div>
                )}
              </div>
            )}

            <div className={`form-group ${this.state.error_yob ? 'has-error' : ''}`}>
              <label>
                Year of birth <RequiredMark />
              </label>
              <select
                style={{ width: 100, color: this.state.yob != '' ? '#555' : '#999' }}
                disabled={this.editMode || this.disablePatientFields}
                readOnly={this.editMode || this.disablePatientFields}
                className="form-control"
                value={this.state.yob}
                onChange={(e) => {
                  this.setState({ yob: e.target.value, enableSubmit: this.toggleSubmit('yob', e.target.value) });
                }}
                onClick={() => {
                  if (this.state.yob == '') {
                    this.setState({ yob: '1970', enableSubmit: this.toggleSubmit('yob', '1970') });
                  }
                }}
              >
                <option value="" disabled selected hidden>
                  YOB
                </option>
                {_.map(this.dateRange, (a) => {
                  return (
                    <option value={a} key={a}>
                      {a}
                    </option>
                  );
                })}
              </select>
              {this.state.error_yob && <div className="error-message">{this.state.error_yob}</div>}
            </div>

            <div className={`form-group ${this.state.error_gender ? 'has-error' : ''}`}>
              <label>
                Gender <RequiredMark />
              </label>
              <select
                disabled={this.editMode || this.disablePatientFields}
                readOnly={this.editMode || this.disablePatientFields}
                style={{ width: 100, color: this.state.gender != '' ? '#555' : '#999' }}
                className="form-control"
                value={this.state.gender}
                onChange={(e) => {
                  this.setState({ gender: e.target.value, enableSubmit: this.toggleSubmit('gender', e.target.value) });
                }}
              >
                <option value="" disabled selected hidden>
                  Gender
                </option>
                <option value="NA">Not specified</option>
                <option value="MALE">Male</option>
                <option value="FEMALE">Female</option>
              </select>
              {this.state.error_gender && <div className="error-message">{this.state.error_gender}</div>}
            </div>
            <div className="row">
              <div className={`form-group col-md-6 ${this.state.error_doc_id ? 'has-error' : ''}`}>
                <label>
                  Provider Code/NPI# <RequiredMark />
                </label>
                <input
                  readOnly={this.editMode}
                  type="text"
                  style={{ width: 200 }}
                  value={this.state.doc_id}
                  onChange={(e) => {
                    let trimmedValue = e.target.value.trim().replaceAll(' ', '');

                    if (trimmedValue.length > 10) {
                      return;
                    }
                    if (trimmedValue.indexOf('-') !== -1) {
                      return;
                    }

                    if (trimmedValue != '') {
                      if (/^[A-Za-z0-9]+$/gi.test(trimmedValue) === false) {
                        return;
                      }
                    }

                    let maskedValue = trimmedValue;
                    if (this.state.officeDetail.npi_format_required === 'Y') {
                      let targetArr = [];
                      if (trimmedValue != '') {
                        targetArr = trimmedValue.match(/.{1,3}/g);
                        maskedValue = targetArr.join('  ');
                      }
                    }

                    this.setState({
                      doc_id: maskedValue,
                      patient_ref: this.state.ref_id + this.state.pat_ini + '-' + trimmedValue,
                      enableSubmit: this.toggleSubmit('doc_id', trimmedValue),
                    });
                  }}
                  className="form-control"
                  placeholder="DCODE"
                />
                {this.state.error_doc_id && <div className="error-message">{this.state.error_doc_id}</div>}
              </div>
              <div className={`form-group col-md-4 ${this.state.error_doctor_comment ? 'has-error' : ''}`}>
                <label>Provider Remark </label>
                <br />
                <input
                  readOnly={this.editMode || this.disablePatientFields}
                  value={this.state.doctor_comment}
                  onChange={(e) => {
                    this.setState({
                      doctor_comment: e.target.value,
                      enableSubmit: this.toggleSubmit('doctor_comment', e.target.value),
                    });
                  }}
                  className="form-control"
                  placeholder="..."
                  type="text"
                />
              </div>
              {this.state.error_doctor_comment && (
                <div className="error-message">{this.state.error_doctor_comment}</div>
              )}
            </div>

            {((this.state.officeDetail && this.state.officeDetail.hl7_match_2_required === 'Y') ||
              this.state.hl7_match_2) && (
              <div className={`form-group ${this.state.error_hl7_match_2 ? 'has-error' : ''}`}>
                <label>
                  2nd Matching Value <br /> (Format required YYYYMMDD) <RequiredMark />
                </label>
                <input
                  readOnly={this.editMode || this.disablePatientFields}
                  type="text"
                  value={this.state.hl7_match_2_mask_value}
                  className="form-control"
                  placeholder="2nd Matching Value"
                  style={{ width: 200 }}
                  onChange={(e) => {
                    let matchTrimmedValue = e.target.value.trim().replaceAll(' ', '');

                    if (matchTrimmedValue.length > 8) {
                      return;
                    }

                    let matchArr = [];
                    let matchMaskValue = matchTrimmedValue;
                    if (matchTrimmedValue != '') {
                      matchArr = matchTrimmedValue.match(/.{1,2}/g);
                      if (matchArr[1]) {
                        matchArr[0] = `${matchArr[0]}${matchArr[1]}`;
                        matchArr.splice(1, 1);
                      }
                      matchMaskValue = matchArr.join('  ');
                    }

                    this.setState({
                      hl7_match_2_mask_value: matchMaskValue,
                      hl7_match_2: matchTrimmedValue,
                      enableSubmit: this.toggleSubmit('hl7_match_2', e.target.value),
                    });
                  }}
                />
                {this.state.error_hl7_match_2 && <div className="error-message">{this.state.error_hl7_match_2}</div>}
              </div>
            )}
            <div className="row">
              <div className={`form-group col-xs-10 ${this.state.error_journey_id ? 'has-error' : ''}`}>
                <label>
                  Journey <RequiredMark />
                </label>
                <input
                  readOnly={this.editMode && this.state.journey.change_group == null}
                  type="text"
                  value={this.state.journey.journey_name}
                  className="form-control"
                  placeholder="Journey"
                />
                {this.state.error_journey_id && <div className="error-message">{this.state.error_journey_id}</div>}
              </div>
              <div style={{ marginTop: 25 }} className="col-xs-2">
                <button
                  disabled={this.editMode && this.state.journey.change_group == null}
                  type="button"
                  onClick={() => {
                    this.setState({ journeyModal: true });
                  }}
                  className="btn btn-md btn-primary"
                >
                  Select
                </button>
              </div>
            </div>

            {this.state.journey && this.state.journey.support_bp_device === 'Y' && (
              <div
                className="row"
                style={{ marginBottom: 15, padding: 10, paddingLeft: 20, backgroundColor: '#c7eaf2' }}
              >
                <div>
                  <label>
                     
                    BP Read Method  
                  </label>
                    <select
                      className="form-control"
                      value={this.state.bp_method}
                      onChange={(e) => {
                        this.setState({
                          bp_method: e.target.value,
                        });
                      }}
                      style={{ width: 200, display: 'inline-block', marginLeft: 10 }}
                    >
                      {
                        this.state.allowed_bp_methods.map((method) => {
                          return (
                            <option value={method} key={method}>
                              {BP_METHODS[method] || method}
                            </option>
                          );
                        }) 
                      }
                      </select>

                </div>
              </div>
            )}

            {this.state.journey &&
              this.state.journey.category === 'HTN' &&
              this.state.officeDetail &&
              this.state.officeDetail.weight_required_default === 'Y' && (
                <div
                  className="row"
                  style={{
                    marginBottom: 15,
                    paddingTop: 10,
                    paddingBottom: 10,
                    paddingLeft: 5,
                    backgroundColor: '#AFE1AF',
                  }}
                >
                  <div className="col-md-6 checkbox">
                    <label>
                      <input
                        type="checkbox"
                        checked={this.state.weight_required}
                        onChange={(e) => {
                          this.setState({
                            weight_required: e.target.checked,
                          });
                        }}
                      />
                      Request for Weight
                    </label>
                  </div>
                  {this.state.weight_baseline_required && (
                    <div className="col-md-6">
                      <label>Weight Baseline:</label>
                      <input
                        style={{ display: 'inline-block', marginLeft: 10, width: 100 }}
                        value={this.state.weight_baseline}
                        onChange={(e) => {
                          let trimmedBaseline = e.target.value.trim().replaceAll(' ', '');

                          if (trimmedBaseline != '') {
                            if (/^[0-9]+$/gi.test(trimmedBaseline) === false) {
                              return;
                            }
                          }

                          this.setState({
                            weight_baseline: trimmedBaseline,
                          });
                        }}
                        className="form-control"
                        type="text"
                      />
                    </div>
                  )}
                </div>
              )}

            {this.state.journey && this.state.journey.has_guard_rail === 'Y' && (
              <DMCustomRange
                jid={this.state.journey.JID}
                category={this.state.journey.category}
                all_rails={this.all_rails}
                guard_rails={this.guard_rails}
                ref={(ref) => (this.DMCustomRange = ref)}
                show_emergency_alert={this.state.journey.show_emergency_alert === 'Y'}
              />
            )}

            {this.state.journey && this.state.journey.show_emergency_alert === 'Y' && (
              <div className="form-group">
                <label style={{ fontWeight: 'bold' }}>Set Emergency Alert Message:</label>
                <textarea
                  style={{ minHeight: 200 }}
                  className="form-control"
                  placeholder={this.state.fallback_emergency_msg_txt}
                  value={this.state.emergency_msg_txt}
                  onChange={(e) => {
                    this.setState({ emergency_msg_txt: e.target.value });
                  }}
                ></textarea>
                <div className="add-phone-link" style={{ marginBottom: '50px', marginTop: '20px' }}>
                  <div className="input-group">
                    <input
                      value={this.state.phone_link}
                      type="text"
                      placeholder="Phone Number"
                      className="form-control"
                      onChange={(e) => {
                        this.setState({
                          phone_link: e.target.value,
                        });
                      }}
                    />
                    <span className="input-group-btn">
                      <button
                        type="button"
                        className="btn btn-success"
                        onClick={() => {
                          this.addPhoneLink();
                        }}
                      >
                        + Add Phone Link
                      </button>
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div style={{ width: '100%' }} className="row col-md-12">
              {!this.editMode && (
                <button
                  disabled={this.state.loading == true || !this.state.enableSubmit}
                  type="button"
                  onClick={() => {
                    this.confirmSaveTCode();
                  }}
                  className="col-sm-6 btn btn-success"
                >
                  Generate T-Code and Save
                </button>
              )}
              {this.editMode && (
                <button
                  disabled={this.state.loading == true}
                  type="button"
                  onClick={() => {
                    this.confirmUpdateTCode();
                  }}
                  className="col-sm-6 btn btn-success"
                >
                  Save Changes
                </button>
              )}

              <button
                type="button"
                onClick={() => {
                  this.goToPatientList();
                }}
                className="col-sm-6 btn btn-danger"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
        {this.editMode
          ? this.state.journeyModal && (
              <JourneySwitcher
                onSelect={(journey) => {
                  // we merge here because on edit, the journey state contains
                  // extra information that are not from journey_main table
                  journey = { ...this.state.journey, ...journey };
                  this.handleJourneySelect(journey);
                }}
                jid={this.state.journey.JID}
                onClose={() => {
                  this.setState({ journeyModal: false });
                }}
              />
            )
          : this.state.journeyModal && (
              <JourneyChooser
                RMG={_.get(this.state, 'officeDetail.RMG', false)}
                MGDEMO={_.get(this.state, 'officeDetail.MGDEMO', false)}
                TEST={_.get(this.state, 'officeDetail.TEST', false)}
                RTTEST={_.get(this.state, 'officeDetail.RTTEST', false)}
                VAHEALS={_.get(this.state, 'officeDetail.VAHEALS', false)}
                CAWATTS={_.get(this.state, 'officeDetail.CAWATTS', false)}
                PACONS={_.get(this.state, 'officeDetail.PACONS', false)}
                CAAIHS={_.get(this.state, 'officeDetail.CAAIHS', false)}
                CAPEACH={_.get(this.state, 'officeDetail.CAPEACH', false)}
                DEPPHQ8={_.get(this.state, 'officeDetail.DEPPHQ8', false)}
                RTCLONES={_.get(this.state, 'officeDetail.RTCLONES', false)}
                CATEGORYBASED={_.get(this.state, 'officeDetail.CATEGORYBASED', false)}
                vasentara={_.get(this.state, 'officeDetail.vasentara', false)}
                WCCHC={_.get(this.state, 'officeDetail.WCCHC', false)}
                onSelect={(journey) => {
                  this.handleJourneySelect(journey);
                }}
                onClose={() => {
                  this.setState({ journeyModal: false });
                }}
              />
            )}
        <Alert
          ref={(a) => {
            this.alert = a;
          }}
        />
        {this.getNewAlert()}
        <ConfirmationModal
          show={this.state.confirmationModal}
          title={BP_TITLES[this.state.bp_method]}
          confirmationText={
            BP_CONFIRMATIONS[this.state.bp_method]
            
          }

          
          handleConfirm={() => {
            if (this.editMode) {
              this.updateTCode();
            } else {
              this.saveTCode();
            }
          }}
          handleClose={() => {
            this.setState({ confirmationModal: false });
          }}
        />
        <ConfirmationModal
          show={this.state.infoConfirmModal}
          title="Are these values correct?"
          handleConfirm={() => {
            this.saveTCode(null);
          }}
          handleClose={() => {
            this.setState({ infoConfirmModal: false });
          }}
        >
          <div className="info-confirmation-modal">
            <div className="row">
              <div className="col-md-6">
                <span className="info-confirmation-label">App Code:</span>
                {this.user_role == Api.ROLE_MANAGER || this.user_role === Api.ROLE_SUPER
                  ? this.state.selected_app
                  : localStorage.getItem('app_code')}
              </div>
              {this.state.groups.length > 0 && (
                <div className="col-md-6">
                  <span className="info-confirmation-label">Group:</span>
                  {this.state.group_name}
                </div>
              )}
            </div>
            <div className="row">
              <div className="col-md-12">
                <span className="info-confirmation-label">Medical Record Number:</span>
                {this.state.ref_id}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <span className="info-confirmation-label">Patient Initials:</span>
                {this.state.pat_ini}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <span className="info-confirmation-label">Year of Birth:</span>
                {this.state.yob}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <span className="info-confirmation-label">Gender:</span>
                {this.state.gender}
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <span className="info-confirmation-label">Provider Code/NPI#:</span> {this.state.doc_id}
              </div>
              <div className="col-md-6">
                <span className="info-confirmation-label">Provider Remark:</span>
                {this.state.doctor_comment}
              </div>
            </div>
            {this.state.officeDetail && this.state.officeDetail.hl7_match_2_required === 'Y' && (
              <div className="row">
                <div className="col-md-12">
                  <span className="info-confirmation-label">2nd Matching Value:</span>
                  {this.state.hl7_match_2_mask_value}
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-md-12">
                <span className="info-confirmation-label">Journey:</span>
                {this.state.journey.journey_name}
              </div>
            </div>
          </div>
        </ConfirmationModal>
      </div>
    );
  }
}
